// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3FlOU","signatureBlock":"Footer_signatureBlock__1HZ8i","signature":"Footer_signature__3tB2E"};